import type { MetaCampaign, MetaKpis } from "../lib/meta-ads";
import { formatCurrency, formatInt, formatPercent } from "../lib/format";

type Row = MetaCampaign & { kpis: MetaKpis };

type MetaCampaignTableProps = {
  rows: Row[];
  currency: string;
};

export function MetaCampaignTable({ rows, currency }: MetaCampaignTableProps) {
  if (rows.length === 0) {
    return (
      <div className="empty">
        <p>No campaigns yet — they'll appear here as soon as the first sync succeeds.</p>
      </div>
    );
  }

  const sorted = [...rows].sort((a, b) => b.kpis.spend - a.kpis.spend);

  return (
    <div className="table-wrap">
      <table className="campaign-table">
        <thead>
          <tr>
            <th>Campaign</th>
            <th>Status</th>
            <th>Objective</th>
            <th className="num">Impr.</th>
            <th className="num">Clicks</th>
            <th className="num">CTR</th>
            <th className="num">Spend (30d)</th>
            <th className="num">Conv.</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((r) => (
            <tr key={r.id}>
              <td>{r.name}</td>
              <td>
                <span
                  className="status-pill"
                  data-status={(r.effective_status ?? r.status).toLowerCase()}
                >
                  {r.effective_status ?? r.status}
                </span>
              </td>
              <td className="muted">{r.objective ?? "—"}</td>
              <td className="num">{formatInt(r.kpis.impressions)}</td>
              <td className="num">{formatInt(r.kpis.clicks)}</td>
              <td className="num">{formatPercent(r.kpis.ctr)}</td>
              <td className="num">{formatCurrency(r.kpis.spend, currency)}</td>
              <td className="num">{formatDecimal(r.kpis.conversions)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function formatDecimal(n: number): string {
  return n.toFixed(n < 10 ? 2 : 0);
}
